/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ClientIntake {
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;

    declare var screenfull: any;
    const WAIT_TO_CLOSE_FORM = 15000;

    class ClientIntakeController {
        static $inject = [
            'meevo.components.modal.ModalService',
            'meevo.ContextParams',
            'meevo.plugins.clientIntakeForm.ClientIntakeFormService',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService',
            'meevo.AppSettings',
            '$rootScope',
            '$scope',
            '$state',
            '$translate',
            '$sce',
        ];

        public formUrl: string;
        public formSubmitted: boolean;

        private shortcutGroup: Meevo.Components.ShortCuts.IShortCutGroup;
        private timeoutId: NodeJS.Timer;
        private iframeEventHandler;

        public get isFromSelfCheckIn(): boolean {
            return this.contextParams.params && this.contextParams.params.fromState ===  this.appSettings.ROUTE_NAMES.selfCheckInKiosk;
        }

        private get clientId(): string {
            if (this.contextParams.params && this.contextParams.params.clientId) {
                return this.contextParams.params.clientId;
            }

            return null;
        }

        constructor(
            protected modalService: Meevo.Components.Modal.IModalService,
            protected contextParams: Meevo.IContextParams,
            protected clientIntakeService: Meevo.Plugins.ClientIntakeForm.ClientIntakeFormService,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: ng.ui.IStateService,
            protected $translate: angular.translate.ITranslateService,
            protected $sce: ng.ISCEService,
        ) {
            if (screenfull.enabled) {
                screenfull.request();
            }

            this.shortcutGroup = new ShortCutGroup([], {
                deactivateGlobal: true,
                groupLevel: Components.ShortCuts.GroupLevels.Modal
            });
            this.shortCutsService.activateGroup(this.shortcutGroup);

            this.prepareUrl();

            this.iframeEventHandler = (event: MessageEvent) => {
                if (event.data === 'intakeFormSubmitted') {
                    this.onSubmit();
                }

                if (event.data === 'intakeFormCanceled') {
                    this.closeForm();
                }
            };

            // Create IE + others compatible event handler
            const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
            const eventer = window[eventMethod];
            const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

            // Listen to message from child window
            eventer(messageEvent, this.iframeEventHandler, false);
        }

        public closeForm() {
            const eventMethod = window.addEventListener ? 'removeEventListener' : 'detachEvent';
            const eventer = window[eventMethod];
            const messageEvent = eventMethod === 'detachEvent' ? 'onmessage' : 'message';
            eventer(messageEvent, this.iframeEventHandler, false);

            clearTimeout(this.timeoutId);
            this.$scope.$broadcast(Meevo.Components.Common.Messages.CLOSE_KIOSK_MODE_OUTSIDE);
        }

        public closeContext(): void {
            const eventMethod = window.addEventListener ? 'removeEventListener' : 'detachEvent';
            const eventer = window[eventMethod];
            const messageEvent = eventMethod === 'detachEvent' ? 'onmessage' : 'message';
            const callbackState = this.contextParams.params && this.contextParams.params.fromState ? this.contextParams.params.fromState : null;
            eventer(messageEvent, this.iframeEventHandler, false);
            clearTimeout(this.timeoutId);
            this.shortCutsService.deactivateGroup(this.shortcutGroup);
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, callbackState, false);
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_INTAKE_FORM);
        }

        private prepareUrl(): void {
            this.busyService.start();
            this.clientIntakeService.getIntakeFormSettings()
                .then((res) => {
                    let url = res.clientIntakeFormsUrl;
                    if (this.clientId) {
                        url += `&c=${this.clientId}`;
                    }

                    this.formUrl = this.$sce.trustAsResourceUrl(`${url}&meevo=1`);
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        private onSubmit() {
            if (!this.clientId) {
                this.formSubmitted = false;

                this.modalService.alert('MESSAGE_THANK_YOU_FOR_SUBMITTING', ModalTranslationModes.Translate)
                    .then((response: boolean) => {
                        const frame = <HTMLFrameElement>angular.element('#client-intake-form-iframe')[0];
                        frame.contentWindow.postMessage('intakeFormInit', '*');
                    });

                return;
            }

            this.timeoutId = setTimeout(() => {
                this.closeForm();
            }, WAIT_TO_CLOSE_FORM);

            this.formSubmitted = true;
            this.$scope.$apply();
        }
    }

    angular.module('meevo.plugins.clientIntake')
        .controller('meevo.plugins.clientIntake.ClientIntakeController', ClientIntakeController);
}
